<template>
  <div>
    <gj-tooltip
        :text-line="1"
        :content="row.listingTitle">
      {{row.listingTitle | defaultShow}}
    </gj-tooltip>
    <div v-if="type === 'msku'">
      <span class="gj-table--label">MSKU：</span>{{row.msku | defaultShow}}
    </div>
    <div v-if="type === 'asin'">
      <span class="gj-table--label">ASIN：</span><gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
    </div>
    <div v-if="type === 'variationAsin'">
      <el-row>
        <el-col :span="12">
          <span class="gj-table--label">父ASIN：</span>
          <template v-if="row.nonVariationAsin">
            -
          </template>
          <template v-else>
            <gj-link :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
          </template>
        </el-col>
        <el-col :span="12">
          <template v-if="row.nonVariationAsin">
            <span class="gj-table--label">ASIN：</span><gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
          </template>
          <template v-else>
            <gj-popover-panel
                :title="'子ASIN'"
                :width="'200px'"
                :data="row.asinList | asinList"
                placement="right">
              <span class="gj-table--label">ASIN：</span><gj-link :href="row.asinUrl" target="_blank" style="margin-right: 2px;">{{row.asin | defaultShow}}</gj-link>
            </gj-popover-panel>
          </template>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "app-dashboard-rank-product-column",
    props: {
      type: {
        required: true
      },
      row: {
        required: true
      }
    },
    filters: {
      asinList(asinList) {
        return (asinList || []).map(item => ({
          label: item.asin
        }))
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-icon-arrow-down {
    font-weight: bold;
  }
</style>
